<template>  
  <div>
    <v-layout>
      <v-flex md8 class="px-4">
        <h3>Años fiscales</h3>
			</v-flex>
      <v-flex md4 class="px-4">
        <template v-if="myPermissions.includes(12)">
          <v-btn color="primary" @click="redirec" class="float-r">Gestionar Estándares</v-btn>
        </template>
			</v-flex>
    </v-layout>
    <br>
		<v-data-table
			hide-default-footer
			:headers="headers"
			:items="filtered_items"
			class="tablaT1"
			 :class="dark_t?'dark':''">
			<template v-slot:item="props">
				<tr>
					<fs1 tag='td' style="text-align:left !important">{{props.item.name}}</fs1>
					<fs1 tag='td' style="text-align:left !important">{{props.item.related_asi_area}}</fs1>
					<fs1 tag='td' style="text-align:left !important">{{props.item.owner_full_name}}</fs1>
					<fs1 tag='td'>{{props.item.due_date}}</fs1>
					<fs1 tag='td' :prop="st = due_date_status(props.item)">
						<span :class="['safety-tag', due_date_status_color[st]]">{{st}}</span>
					</fs1>
					<fs1 tag='td'>
						<a :href="props.item.file" target="_blank" v-if="props.item.file">
							<v-icon >insert_drive_file</v-icon>
						</a>
					</fs1>
				</tr>
			</template>
		</v-data-table>

  </div>	
</template>

<script>
import due_date_status from '@/components/mixins/due_date_status';

export default {
  mixins: [due_date_status],
  computed: {
		filtered_items(){ return this.items },
		items (){ return this.$store.getters.standards },
    headers() {
      return [
				{ text: 'Nombre', sortable: false, value: 'name' },
				{ text: 'Área', sortable: false, value: 'related_asi_area' },
				{ text: 'Dueño', sortable: false, value: 'owner_full_name' },
				{ text: 'Fecha de vencimiento', sortable: true, value: 'due_date' },
				{ text: 'Estado', sortable: true, value: 'due_date' },
				{ text: 'Archivo', sortable: false, value: 'file' },
      ];
    },
  },
  methods: {
		redirec(){this.$router.push({ name: 'admin/standars'})}
  },
};
</script>
